import * as React from "react";

import * as FeatureToggleNames from "@teamprevent/common/featureToggleNames";
import { getFeatureToggles } from "@teamprevent/common/getFeatureToggles";

import { StatisticsGridAndLoaderNew } from "./StatisticsGridAndLoaderNew";

export const StatisticsGridAndLoader = () => {
    const isMuiMigrationEnabled = getFeatureToggles()[FeatureToggleNames.EnableMuiMigration];
    if (isMuiMigrationEnabled) {
        return <StatisticsGridAndLoaderNew />;
    }

    return <StatisticsGridAndLoaderNew />;
};
